module.exports = __webpack_public_path__ + "img/galery-kx5200-3-zoom.5d1cbf51.png";